import React from "react";
import { Link } from "react-router-dom";

export default function AboutUs() {
  return (
    <div className="">
      <div className="flex flex-col justify-center align-middle py-10">
        <h1 className="text-2xl md:text-5xl font-bold mb-3 pb-2">
          About BrioCart
        </h1>
        <hr className="border-x-2 border-gray-300" />
      </div>
      <p className="my-7 text-lg text-justify">
        BrioCart is an eCommerce Web Development Project for Educational
        Purposes only.
      </p>
      <p className="my-7 text-lg text-justify">
        Welcome to BrioCart, where innovation meets convenience! Our ecommerce
        web development project is aimed at creating a seamless and enjoyable
        online shopping experience. With a focus on user-friendly interfaces,
        robust functionality, and secure transactions, BrioCart is designed to
        empower businesses and delight customers.
      </p>
      <h3 className="mb-5 text-2xl font-semibold text-ambhosOrange">
        Project Overview
      </h3>
      <p className="mt-1 text-lg text-justify">
        BrioCart is a cutting-edge ecommerce web development project that aims
        to revolutionize the way people shop online. Whether you're a small
        boutique store or a large retail enterprise, our platform provides
        tailored solutions to meet your unique business needs. From user
        authentication and product browsing to payment processing and order
        management, every aspect is meticulously crafted to enhance user
        satisfaction and boost sales.
      </p>
    </div>
  );
}
